export default {"src":"/planos/_next/static/media/equifax-cloud-connections.cc055aa9.svg","height":32,"width":29,"blurWidth":0,"blurHeight":0};